import { http } from '@/http'

export default {

    index:      (params)    =>  http.get('occurrence_sheet_settings', { params: params }),
    show:       (id)        =>  http.get('occurrence_sheet_settings/' + id),
    store:      (data)      =>  http.post('occurrence_sheet_settings', data),
    update:     (data)      =>  http.put('occurrence_sheet_settings/' + data.id, data),
    destroy:    (id)        =>  http.delete('occurrence_sheet_settings/' + id),

}
